import _BaseAPIService from "./_BaseAPIService";

const apiService = _BaseAPIService.instance;
const QuizService = {
  getList: async () => {
    const response = await apiService.get("/quizquestions");
    return response.data;
  },
  retakeQuiz: async (slug) => {
    const response = await apiService.get(`/quizdraft/re-take/${slug}`);
    return response.data;
  },
  getbyId: async (id) => {
    console.log(id);
    const response = await apiService.get(`/quizquestions/${id}`);
    return response.data;
  },
  submit: async (payload) => {
    const response = await apiService.post("/quizquestions/submit", payload);
    return response.data;
  },
  draft: async (payload) => {
    const response = await apiService.post("/quizdraft", payload);
    return response.data;
  },
  draftGet: async (slug) => {
    const response = await apiService.get(`/quizdraft/latest/${slug}`);
    return response.data;
  },
  resetAll: async (id) => {
    const response = await apiService.delete(`/quizdraft/${id}/delete-all-drafts`);
    return response.data;
  },
  getQuizById: async (id) => {
    const response = await apiService.get(`/quizquestions/${id}/quizzes`);
    return response.data;
  },

  getbyslug: async (slug) => {
    const response = await apiService.get(`/quizquestions/${slug}`);
    return response.data;
  },
  submitCertificate: async (formData) => {
    const token = localStorage.getItem("user")
      ? JSON.parse(localStorage.getItem("user"))?.token
      : null;

    console.log("=== CERTIFICATE SUBMIT DEBUG ===");
    const entries = [...formData.entries()];
    console.log("FormData entries count:", entries.length);
    entries.forEach(([key, value]) => {
      console.log(`  Key: "${key}"`, value);
      if (value instanceof File) {
        console.log(`    → File name: ${value.name}`);
        console.log(`    → File size: ${value.size} bytes`);
        console.log(`    → File type: ${value.type}`);
      }
    });

    const fileEntry = formData.get("file");
    const freshFormData = new FormData();
    freshFormData.append("file", fileEntry);

    // 👇 PASTE IT RIGHT HERE — replaces the old fetch block
    let response;
    try {
      response = await fetch(
        `${window.APP_CONFIG.api1.baseapi}/certificateemail/send-certificate`,
        {
          method: "POST",
          headers: { Authorization: `Bearer ${token}` },
          body: freshFormData,
        },
      );
      console.log("✅ Response status:", response.status);
      const responseText = await response.text();
      console.log("✅ Server response body:", responseText);
    } catch (networkError) {
      console.error("❌ NETWORK ERROR (fetch threw):", networkError.message);
      console.error("   This is likely CORS, SSL mismatch, or wrong base URL");
      console.error("   Base URL used:", window.APP_CONFIG.api1.baseapi);
      throw networkError;
    }
  },
};

export default QuizService;
